import { apiUrl } from "./apiClient";

/**
 * Main-database vehicle catalogue (Hyundai carlines; WP2) for the Claims
 * form and the Dashboard.
 *
 * Uses fetch(), so the global auth interceptor (utils/authInterceptor.js)
 * adds the session cookie and handles 401/403 exactly as for the dashboard
 * calls. The catalogue is loaded once per page load and shared; a failed load
 * is not cached, so the next call retries.
 *
 * GET /vehicle-catalogue          -> { manufacturers, models, data_notice }
 * GET /vehicle-catalogue/resolve  -> { status, model, candidates, reason }
 */

let cataloguePromise = null;

async function getJson(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

export function fetchVehicleCatalogue() {
  if (!cataloguePromise) {
    cataloguePromise = getJson(apiUrl("/vehicle-catalogue")).then((body) => {
      if (!Array.isArray(body?.manufacturers) || !Array.isArray(body?.models)) throw new Error("Malformed catalogue");
      return body;
    }).catch((error) => {
      cataloguePromise = null;
      throw error;
    });
  }
  return cataloguePromise;
}

/** Test hook: forget the cached catalogue. */
export function resetVehicleCatalogueCache() {
  cataloguePromise = null;
}

/** Resolve a free-text model name (e.g. from image extraction) to exactly one catalogue model, or say why not. */
export function resolveVehicleModel(modelName) {
  const params = new URLSearchParams({ model_name: modelName || "" });
  return getJson(apiUrl(`/vehicle-catalogue/resolve?${params}`));
}

/** Models of one manufacturer, in catalogue order. */
export function modelsOf(catalogue, manufacturerCode) {
  return (catalogue?.models || []).filter((m) => m.manufacturer_code === manufacturerCode);
}
